import axiosInstance from '../services/axiosCreator';

interface McGrawHillResponse<T> {
  success: boolean;
  data: T;
  error?: string;
}

const unwrap = <T>(response: McGrawHillResponse<T>): T => {
  if (!response.success) {
    throw new Error(response.error ?? 'McGraw Hill request failed');
  }

  return response.data;
};

/** Makes the textbook's exam the caller's active exam. 404 for unknown slugs. */
export const selectMcGrawHillBook = async (
  slug: string
): Promise<{ examId: string }> => {
  const response = await axiosInstance.post<
    McGrawHillResponse<{ examId: string }>
  >('/api/v5/mcgraw-hill/select', { slug });

  return unwrap(response.data);
};

/**
 * A reference figure's image (members only; it is client art, so it has no
 * public URL). The caller owns the returned object URL and revokes it.
 */
export const fetchMcGrawHillFigureUrl = async (
  figureId: string
): Promise<string> => {
  const response = await axiosInstance.get<Blob>(
    `/api/v5/mcgraw-hill/figures/${encodeURIComponent(figureId)}`,
    { responseType: 'blob' }
  );

  return URL.createObjectURL(response.data);
};
